
<app-pcbread-crumb [data]="'Stock,WarehouseHandling'"></app-pcbread-crumb>
<app-warehouse-handling-report  (outputParentAction)="parentAction($event)"></app-warehouse-handling-report>

<app-warehouse-handling-detail (outputParentAction)="parentAction($event)"></app-warehouse-handling-detail>

<app-fast-warehouse-handling (outputParentAction)="parentAction($event)"></app-fast-warehouse-handling>